import { computed } from "mobx";

import Entity from "lib/models/Entity";

export type MajorTagType = "VISA_TYPE" | "TOPIC" | "LAWFULLY_PICK";

export enum MajorTagEnum {
  VISA_TYPE = "Visa Type",
  TOPIC = "Topic",
  LAWFULLY_PICK = "Lawfully's Pick",
}

interface MajorTagSource {
  id: number;
  name: string;
  isActive: boolean;
  newsType: MajorTagType;
  order: number;
}

export default class MajorTag extends Entity<MajorTagSource> {
  @computed
  get name(): string {
    return this.source.name;
  }

  @computed
  get isActive(): boolean {
    return this.source.isActive;
  }

  @computed
  get newsType(): MajorTagType {
    return this.source.newsType;
  }

  @computed
  get order(): number {
    return this.source.order;
  }
}

export type { MajorTagSource };
